import React, {Component} from 'react';
import LateralsContent from '../function-components/LateralsContent'

function Laterals() {
    return (
      <>
          <LateralsContent />
      </>
    )
  }

export default Laterals;